export const MAP_LIBRARIES: ('places')[] = ['places'];

/** Pune default — same as doctor vendor timeslot flow */
export const DEFAULT_MAP_CENTER = { lat: 18.5204, lng: 73.8567 };

export const sanitizePincodeInput = (value: string) =>
  String(value ?? '').replace(/\D/g, '').slice(0, 6);

export const hasValidClinicCoordinates = (
  latitude: number | null | undefined,
  longitude: number | null | undefined,
  address: string
) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  const isDefaultOnly =
    Math.abs(lat - DEFAULT_MAP_CENTER.lat) < 0.0001 &&
    Math.abs(lng - DEFAULT_MAP_CENTER.lng) < 0.0001 &&
    !address.trim();
  return !isDefaultOnly;
};

export const extractPincodeFromAddressComponents = (
  components?: google.maps.GeocoderAddressComponent[]
) => {
  if (!Array.isArray(components)) return '';
  const pinObj = components.find((c) => c.types.includes('postal_code'));
  return pinObj?.long_name || '';
};
